import { ReusableTable } from 'components/Tables/ReusableTable'
import { useProject } from 'context/ProyectoContext'
import React, { useEffect, useState } from 'react'
import { ImCross } from 'react-icons/im'
import { FaCheck } from 'react-icons/fa'
import DeleteIcon from '@mui/icons-material/Delete'
import { IconButton } from '@mui/material'
import ModalDeleteBoQs from './ModalDeleteBoQs'
import toast from 'react-hot-toast'
import { useSearchParams } from 'react-router-dom'
import { useStats } from 'hooks/useStats'

export const DatosPage_v2 = () => {
  let [searchParams] = useSearchParams()
  const [isBoq, setIsBoq] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [currentProgress, setCurrentProgress] = useState(0)

  // Traemos el proyecto y versiones desde el contexto
  const {
    currentProject,
    versions,
    isLoadingCurrentProject: isLoading,
  } = useProject()

  // Obtenemos la versión desde los query params (o la última si no existe param)
  const version = searchParams.get('version')
    ? searchParams.get('version')
    : versions.length

  const { data: stats, isLoading: isLoadingStats } = useStats(
    currentProject._id,
    version
  )

  useEffect(() => {
    fetch(`/api/boq/${currentProject._id}/hasversion/${version}`)
      .then(res => res.json())
      .then(res => setIsBoq(res.hasVersion))
  }, [version, currentProject._id])

  // Reiniciar el progreso cada vez que cambian las stats
  useEffect(() => {
    setCurrentProgress(0)
  }, [stats])

  useEffect(() => {
    if (!isLoadingStats && stats?.progress) {
      let animation
      if (currentProgress < stats.progress) {
        animation = setInterval(() => {
          setCurrentProgress(prev => {
            const nextValue = prev + 0.05
            return nextValue >= stats.progress ? stats.progress : nextValue
          })
        }, 50)
      }
      return () => clearInterval(animation)
    }
  }, [currentProgress, stats?.progress, isLoadingStats])

  const handleDeleteProjectBoqs = () => {
    setIsModalOpen(true)
  }

  const confirmDelete = () => {
    setIsModalOpen(false)
    const loadingToast = toast.loading(
      `Eliminando BoQs de la versión ${currentProject.versionBoQ}...`
    )
    fetch(`/api/boq/all/${currentProject._id}/${currentProject.versionBoQ}`, {
      method: 'DELETE',
    }).then(res => {
      toast.dismiss(loadingToast)
      if (res.ok) {
        toast.success('BoQs eliminados con éxito')
      } else {
        toast.error('Error al eliminar BoQs')
      }
    })
  }

  // Si el proyecto está cargando, mostramos algo de feedback (spinner, texto, skeleton, etc.)
  if (isLoading) return <div>Cargando...</div>

  const dataBody = [
    currentProject.displayName,
    'version',
    isBoq ? <FaCheck /> : <ImCross />,
    versions.length,
    currentProject.versionBoQ,
    <IconButton className="edit-btn" onClick={handleDeleteProjectBoqs}>
      <DeleteIcon fontSize="large" />
    </IconButton>,
  ]

  return (
    <>
      <ReusableTable
        dataHeader={[
          'Modelo',
          'Visible',
          'BoQ?',
          'Disponible',
          'Last BoQ',
          ' ',
        ]}
        dataBody={[dataBody]}
        headerClassNames={[
          'ta-left',
          'ta-left',
          'ta-left',
          'ta-left',
          'ta-left',
        ]}
      />
      <ModalDeleteBoQs
        confirmDelete={confirmDelete}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  )
}
